export function resolvePrice(product, pricing) {
    const price = (product.prices ?? []).find(p =>
        !p.interval || p.interval === pricing
    );

    const stripePrices = product.processorData?.prices ?? [];

    const processorPrice = price
        ? stripePrices.find(p => p.id === price.processorId) ?? stripePrices[0]
        : stripePrices[0];

    return { price, processorPrice };
}

export function resolveAmount(processorPrice, qty) {
    // Stripe's *_decimal fields are decimal strings; coerce to Number so downstream `+` is arithmetic, not concat.
    if (processorPrice.billing_scheme !== 'tiered') {
        return {
            flatCents: 0,
            perUnitCents: Number(processorPrice.unit_amount_decimal ?? 0),
        };
    }

    // Stripe returns tiers in definition order; sort so .find() picks the smallest matching bound.
    const sortedTiers = [...processorPrice.tiers].sort(
        (a, b) => (a.up_to ?? Infinity) - (b.up_to ?? Infinity)
    );

    // Usage is a daily count of active users; monthly tier bounds are expressed in user-days.
    const bucket = qty * 30;
    const tier = sortedTiers.find(t => t.up_to === null || bucket <= t.up_to);

    return {
        flatCents: Number(tier.flat_amount_decimal ?? 0),
        perUnitCents: Number(tier.unit_amount_decimal ?? 0),
    };
}

export function computeLineTotal(processorPrice, qty) {
    const { flatCents, perUnitCents } = resolveAmount(processorPrice, qty);
    return (flatCents + perUnitCents * qty) / 100;
}
